import { isPast, parseISO } from 'date-fns';
import { Middleware } from 'redux';

const queuedActions: any = [];

/**
 * Middleware to refresh the session token if it is expired.
 * Will queue action and replay them after token is refreshed.
 * or logout the user if token can not be refreshed.
 */
const refreshMiddleware: Middleware = (store) => (next) => (action) => {
  const state = store.getState();

  if (state.auth.isRefreshingSession) {
    queuedActions.push(action);
    return;
  }

  if (isPast(parseISO(state.auth.expiration))) {
    queuedActions.push(action);
    return;
  }

  return next(action);
};

export default refreshMiddleware;
